import { TopTabs } from '@/components/dashboard/TopTabs'
import { DashboardSubTabs } from '@/components/dashboard/DashboardSubTabs'
import { SyncShopifyButton } from '@/components/dashboard/SyncShopifyButton'
import { ProductTypeDemandTable } from '@/components/dashboard/ProductTypeDemandTable'

export default function ProductType() {
  return (
    <div className="dash-page brand-theme flex flex-col h-screen bg-[var(--surface-page)] text-[var(--text-primary)]">
      <TopTabs />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '8px 16px',
          borderBottom: '1px solid var(--line-warm)',
          background: 'var(--surface-card)',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ flex: 1 }} />
        <DashboardSubTabs />
        <SyncShopifyButton />
      </div>
      <div className="flex-1 overflow-hidden flex flex-col" style={{ borderTop: '1px solid var(--line-warm)' }}>
        <ProductTypeDemandTable />
      </div>
    </div>
  )
}
